/* eslint-disable import/no-unresolved */
/* eslint-disable react/prop-types */
import React from 'react';
import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';

import style from './style';

function ButtonAtom({
  onClick, id,name, disabled, icon, type, cclass, startIcon, customButtonCss, title, variant
}) {
  const classes = style();

  return (    
      <Button
        id={id}
        type={type}
        variant={variant}
        onClick={onClick}
        className={`${classes.commonBtn} ${classes[cclass]}`}
        style={customButtonCss}
        title={title}
        disabled={disabled}
        startIcon={startIcon}       
        disableRipple
      >
        {name}
        <span>{icon}</span>  
      </Button>    
  );
}

ButtonAtom.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string.isRequired,
  customButtonCss: PropTypes.objectOf(Object),
  color: PropTypes.string,
  title: PropTypes.string,
};

ButtonAtom.defaultProps = {
  onClick: '',
  customButtonCss: {},
  color: 'primary',
  title: '',
};

export default ButtonAtom;